import { FormControl, FormLabel, Switch, Typography } from '@mui/material';
import React from 'react';
import { Helmet } from 'react-helmet';
import { VyPageLayout } from '../../../components/new-design/layout/VyPageLayout';
import { FormErrorNotificationProvider } from '../../../contexts/form-error-notification-context/FormErrorNotificationProvider';
import { CreateCreditNoteBottomToolbar } from './create-credit-note-page-components/CreateCreditNoteBottomToolbar';
import { CreateCreditNoteErrorNotification } from './create-credit-note-page-components/CreateCreditNoteErrorNotification/CreateCreditNoteErrorNotification';
import { withCreateCreditNoteForm } from './create-credit-note-page-components/CreateCreditNoteForm/CreateCreditNoteForm';
import { CreateCreditNotePageContent } from './create-credit-note-page-components/CreateCreditNotePageContent';
import { useCreateCreditNoteContext } from './create-credit-note-page-contexts/create-credit-note-context/create-credit-note-context';
import { withCreateCreditNoteProvider } from './create-credit-note-page-contexts/create-credit-note-context/CreateCreditNoteProvider';

const CreateCreditNotePage: React.FC = () => {
  const {
    planPreview: { open, hide, show },
  } = useCreateCreditNoteContext();

  const handlePlanPreviewSwitch = (_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
    checked ? show() : hide();
  };

  return (
    <VyPageLayout
      path={['Credit Notes', 'Create']}
      title="Create Credit Note"
      sx={{
        padding: '0',
      }}
      action={
        <FormControl className="flex flex-row items-center gap-x-2">
          <FormLabel htmlFor="plan-preview-switch">
            <Typography variant="body1" sx={{
              color: "text.primary"
            }}>
              See Preview
            </Typography>
          </FormLabel>
          <Switch id="plan-preview-switch" checked={open} onChange={handlePlanPreviewSwitch} />
        </FormControl>
      }
    >
      <Helmet>
        <title>Create Credit Note</title>
      </Helmet>
      <FormErrorNotificationProvider>
        <div className="flex h-full flex-col">
          <CreateCreditNotePageContent />
          <CreateCreditNoteBottomToolbar />
          <CreateCreditNoteErrorNotification />
        </div>
      </FormErrorNotificationProvider>
    </VyPageLayout>
  );
};

const CreateCreditNotePageWithPageLayout = withCreateCreditNoteProvider(
  withCreateCreditNoteForm(CreateCreditNotePage),
);

export { CreateCreditNotePageWithPageLayout as CreateCreditNotePage };
